/**
 * 
 * 车辆详情，车辆预定 两个页面数据共享
 */
let initState = {
  carType: {},
  productInfo:{},
  vehicleRentalCost: '',
  orderType: '',
  dayNum: '',
}
const carDetailPickupDropoffInfo = {
    state: {
      carType: {}, //资源，车辆类型
      productInfo:{},//产品信息
      vehicleRentalCost: '', //车辆租赁费用
      orderType: '', // 订单类型 1.常规租车 2. 固定租车
      dayNum: '', //租期
    },
    mutations: {
      setDetailCarType:(state, data) =>{
        state.carType = data
      },
      setProductInfo: (state, data) => {
          state.productInfo = data
      },
      setvehicleRentalCost:(state, data) =>{
        state.vehicleRentalCost = data
      },
      setDetailOrderType:(state, data) =>{
        state.orderType = data
      },
      setDetailDayNum:(state, data) =>{
        state.dayNum = data
      },
      resetCarDetailPickupDropoffInfo (state) {
        Object.keys(state).forEach(key => { state[key] = initState[key]})
      },
    },
    actions: {

    }
}

export default carDetailPickupDropoffInfo



// WEBPACK FOOTER //
// ./src/store/carDetail.js